import { c as _c } from "react/compiler-runtime";
// Возврат после входа через Яндекс ID / VK ID (ТЗ, п. 1.2). Шлюз приводит
// сюда с одноразовым билетом (?ticket=) или кодом ошибки (?error=). Билет
// меняется на токен POST-запросом - токен сессии в адресной строке не бывает.
// Если сервис не отдал телефон - вход по номеру той же карточкой, после него
// внешний аккаунт привязывается к профилю.
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useSearchParams } from "react-router";
import { toast } from "sonner";
import { api, type OAuthExchangeResult } from "@/api";
import { SignInCard } from "@/components/profile/sign-in-card";
import { useProfile, useWishlist } from "@/store";
const TITLES: Record<string, string> = {
  yandex: "Яндекс ID",
  vk: "VK ID"
};
const ERRORS = ["denied", "expired", "provider", "blocked", "taken", "not_configured"] as const;
const safePath = (v: string | null | undefined) => v && v.startsWith("/") && !v.startsWith("//") ? v : "/profile";
export function AuthOAuthPage() {
  const $ = _c(52);
  const {
    t
  } = useTranslation();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const acceptExternalSession = useProfile(_temp);
  const syncWishlist = useWishlist(_temp2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      kind: "loading"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [state, setState] = useState(t0);
  const started = useRef(false);
  let t1;
  if ($[1] !== params) {
    t1 = params.get("ticket");
    $[1] = params;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const ticket = t1;
  let t2;
  if ($[3] !== params) {
    t2 = params.get("error");
    $[3] = params;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const error = t2;
  const providerTitle = TITLES[params.get("provider") ?? ""] ?? "";
  let t3;
  let t4;
  if ($[5] !== acceptExternalSession || $[6] !== error || $[7] !== navigate || $[8] !== providerTitle || $[9] !== syncWishlist || $[10] !== t || $[11] !== ticket) {
    t3 = () => {
      if (started.current) {
        return;
      }
      started.current = true;
      if (error || !ticket) {
        const code = ERRORS.find(e => e === error) ?? "expired";
        setState({
          kind: "error",
          text: t(`oauth.error.${code}`, {
            provider: providerTitle || "\u0421\u0435\u0440\u0432\u0438\u0441"
          })
        });
        return;
      }
      (async () => {
        ;
        try {
          const result = await api.oauth.exchange(ticket);
          if (result.status === "need_phone") {
            setState({
              kind: "need_phone",
              result
            });
            return;
          }
          await acceptExternalSession(result);
          syncWishlist();
          navigate(safePath(result.returnTo), {
            replace: true
          });
        } catch (t5) {
          const e_0 = t5;
          setState({
            kind: "error",
            text: e_0 instanceof Error ? e_0.message : t("oauth.error.expired")
          });
        }
      })();
    };
    t4 = [ticket, error, providerTitle, acceptExternalSession, syncWishlist, navigate, t];
    $[5] = acceptExternalSession;
    $[6] = error;
    $[7] = navigate;
    $[8] = providerTitle;
    $[9] = syncWishlist;
    $[10] = t;
    $[11] = ticket;
    $[12] = t3;
    $[13] = t4;
  } else {
    t3 = $[12];
    t4 = $[13];
  }
  useEffect(t3, t4);
  if (state.kind === "loading") {
    let t5;
    if ($[14] !== t) {
      t5 = t("oauth.completing");
      $[14] = t;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    let t6;
    if ($[16] !== t5) {
      t6 = <p className="py-24 text-center text-[16px] text-[#1F1F1F]/64">{t5}</p>;
      $[16] = t5;
      $[17] = t6;
    } else {
      t6 = $[17];
    }
    return t6;
  }
  if (state.kind === "error") {
    let t5;
    if ($[18] !== state.text) {
      t5 = <p className="text-[16px] leading-[21px] font-medium text-[#2E2E2E]">{state.text}</p>;
      $[18] = state.text;
      $[19] = t5;
    } else {
      t5 = $[19];
    }
    let t6;
    if ($[20] !== params) {
      t6 = safePath(params.get("returnTo"));
      $[20] = params;
      $[21] = t6;
    } else {
      t6 = $[21];
    }
    let t7;
    if ($[22] !== t) {
      t7 = t("oauth.backToSignIn");
      $[22] = t;
      $[23] = t7;
    } else {
      t7 = $[23];
    }
    let t8;
    if ($[24] !== t6 || $[25] !== t7) {
      t8 = <Link to={t6} className="rounded-sm text-[14px] leading-[18px] text-[#1F1F1F] underline-offset-2 outline-none hover:underline focus-visible:ring-2 focus-visible:ring-[#1F1F1F]/40">{t7}</Link>;
      $[24] = t6;
      $[25] = t7;
      $[26] = t8;
    } else {
      t8 = $[26];
    }
    let t9;
    if ($[27] !== t5 || $[28] !== t8) {
      t9 = <div className="flex justify-center py-10 md:pt-[105px] md:pb-[88px]"><div className="flex w-full max-w-[366px] flex-col items-center gap-5 rounded-[20px] bg-[#F8F8F8] p-6 text-center" data-testid="oauth-error">{t5}{t8}</div></div>;
      $[27] = t5;
      $[28] = t8;
      $[29] = t9;
    } else {
      t9 = $[29];
    }
    return t9;
  }
  const {
    result: result_0
  } = state;
  const title = TITLES[result_0.provider] ?? result_0.provider;
  let t5;
  if ($[30] !== t) {
    t5 = t("oauth.needPhoneTitle");
    $[30] = t;
    $[31] = t5;
  } else {
    t5 = $[31];
  }
  let t6;
  if ($[32] !== t5) {
    t6 = <h1 className="text-[20px] leading-[23px] font-semibold text-black">{t5}</h1>;
    $[32] = t5;
    $[33] = t6;
  } else {
    t6 = $[33];
  }
  let t7;
  if ($[34] !== t || $[35] !== title) {
    t7 = t("oauth.needPhoneText", {
      provider: title
    });
    $[34] = t;
    $[35] = title;
    $[36] = t7;
  } else {
    t7 = $[36];
  }
  let t8;
  if ($[37] !== t7) {
    t8 = <p className="mt-2 text-[14px] leading-[18px] text-[#2E2E2E]">{t7}</p>;
    $[37] = t7;
    $[38] = t8;
  } else {
    t8 = $[38];
  }
  let t9;
  if ($[39] !== t6 || $[40] !== t8) {
    t9 = <div className="mx-auto mt-10 max-w-[366px] px-4 text-center md:px-0 md:mt-16" data-testid="oauth-need-phone">{t6}{t8}</div>;
    $[39] = t6;
    $[40] = t8;
    $[41] = t9;
  } else {
    t9 = $[41];
  }
  let t10;
  if ($[42] !== navigate || $[43] !== result_0.returnTo || $[44] !== result_0.ticket || $[45] !== syncWishlist || $[46] !== t || $[47] !== title) {
    t10 = <SignInCard oauth={false} onSignedIn={() => {
      (async () => {
        try {
          await api.oauth.claim(result_0.ticket);
          toast.success(t("oauth.linkedToast", {
            provider: title
          }));
        } catch {
          toast.error(t("oauth.claimFailed", {
            provider: title
          }));
        }
        syncWishlist();
        navigate(safePath(result_0.returnTo), {
          replace: true
        });
      })();
    }} />;
    $[42] = navigate;
    $[43] = result_0.returnTo;
    $[44] = result_0.ticket;
    $[45] = syncWishlist;
    $[46] = t;
    $[47] = title;
    $[48] = t10;
  } else {
    t10 = $[48];
  }
  let t11;
  if ($[49] !== t10 || $[50] !== t9) {
    t11 = <div>{t9}{t10}</div>;
    $[49] = t10;
    $[50] = t9;
    $[51] = t11;
  } else {
    t11 = $[51];
  }
  return t11;
}
function _temp2(s_0) {
  return s_0.syncFromServer;
}
function _temp(s) {
  return s.acceptExternalSession;
}